import { Constants as CreateSurveyConstants } from '../../shared/constants/create-survey.constants';
import {
  LOCATION_QUALIFICATION_CODES as ZIP_LOCATION_QUALIFICATION_CODES,
  QUALIFICATION_CODES,
} from '../../shared/constants/qualification-code';
import { NestingQualification } from '../../shared/interfaces/quota-nesting.interface';
import { Criteria } from '../../shared/interfaces/quota.interface';
import {
  AdvancedCriterionDescriptionBuilder,
  CAGCriterionDescriptionBuilder,
  ChildrenCriterionDescriptionBuilder,
  ConditionCriterionDescriptionBuilder,
  LocationCriterionDescriptionBuilder,
  RangeCriterionDescriptionBuilder,
  ZipCodeCriterionDescriptionBuilder,
} from './criterion-description-builder';
import { SurveyQuotaCriterion } from './survey-quota-criterion';

interface DescriptionBuild {
  build(): string;
}

export class NestedCriterionDescriptionBuilder implements DescriptionBuild {
  public get criterion(): SurveyQuotaCriterion {
    return new SurveyQuotaCriterion(this._criterion);
  }

  constructor(
    private readonly _criterion: Criteria,
    private readonly _selectedQualification: NestingQualification
  ) {}

  public build(): string {
    if (this.criterion.isRange()) {
      return new RangeCriterionDescriptionBuilder(this._criterion).build();
    }

    if (this.criterion.qualificationCode() === QUALIFICATION_CODES.CHILDREN) {
      return new ChildrenCriterionDescriptionBuilder(this._criterion).build();
    }

    if (
      this.criterion.qualificationCode() ===
      QUALIFICATION_CODES.CHILD_AGE_GENDER
    ) {
      return new CAGCriterionDescriptionBuilder(this._criterion).build();
    }

    if (
      this.criterion.qualificationCode() >=
      CreateSurveyConstants.ADVANCE_TARGETING_QUAL_ID_START_INDEX
    ) {
      return new AdvancedCriterionDescriptionBuilder(
        this._criterion,
        this._selectedQualification
      ).build();
    }

    if (
      ZIP_LOCATION_QUALIFICATION_CODES.includes(
        this.criterion.qualificationCode()
      )
    ) {
      return new ZipCodeCriterionDescriptionBuilder(this._criterion).build();
    }

    if (
      this.criterion.conditions().length &&
      this._selectedQualification?.data?.length
    ) {
      return new LocationCriterionDescriptionBuilder(
        this._criterion,
        this._selectedQualification
      ).build();
    }

    if (this.criterion.conditions().length) {
      return new ConditionCriterionDescriptionBuilder(this._criterion).build();
    }

    return CreateSurveyConstants.UNKNOWN_CONDITION;
  }
}
